import { useEffect, useState } from 'react';
import { usePlacesAutocomplete } from 'places-autocomplete-hook';
import Input from '@mui/material/Input';
import { useTranslation } from 'react-i18next';

const apiKey = process.env.REACT_APP_GOOGLE_GEOSERVICES_KEY;

const placeDetails = (place) => {
  let photoURLs = [];

  if (place.photos && place.photos.length > 0) {
    photoURLs = place.photos.map((photo) => `https://places.googleapis.com/v1/${photo.name}/media?key=${apiKey}&maxHeightPx=400&maxWidthPx=400`).filter((url) => url !== null);
  }

  const isCompany = place.types?.includes('establishment') || place.types?.includes('point_of_interest');

  return {
    name: isCompany ? place.name || place.displayName.text : '',
    phone: place.nationalPhoneNumber?.replace(/\s/g, '') || '',
    photos: photoURLs,
    address: place.formattedAddress ? place.formattedAddress : '',
    selectedPhoto: '',
    location: {
      latitude: place.location.latitude,
      longitude: place.location.longitude,
    },
    google_place_id: place.placeId,
    isCompany,
    google_place_info:
      isCompany
        ? {
          price_level: place.price_level ? place.price_level : null,
          rating: place.rating ? place.rating : null,
          user_ratings_total: place.user_ratings_total
            ? place.user_ratings_total
            : null,
          types: place.types ? place.types : null,
        }
        : null,
  };
};

function AutoComplete(props) {
  const { isInterview, handleEnter, propagateUpdates } = props;
  const { t } = useTranslation();
  const [selectedValue, setSelectedValue] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const {
    value,
    suggestions,
    setValue,
    getPlaceDetails,
    handlePlaceSelect,
  } = usePlacesAutocomplete({
    apiKey,
    debounceMs: 500,
    language: 'el',
    includedRegionCodes: ['gr', 'cy'],
  });

  const handleSelect = async (prediction) => {
    const { placeId } = prediction;
    const returnedFields = [
      'formattedAddress',
      'priceLevel',
      'photos',
      'rating',
      'types',
      'userRatingCount',
      'location',
      'displayName',
      'nationalPhoneNumber',
      'internationalPhoneNumber',
    ];

    await handlePlaceSelect(placeId);
    const details = await getPlaceDetails(placeId, returnedFields);

    propagateUpdates(details.formattedAddress, placeDetails(details));
    setValue(details.formattedAddress);
    setSelectedValue(true);
  };

  const handleInputChange = (e) => {
    setValue(e.target.value);
    setSelectedValue(false);
  };
  const handleKeyDown = (e) => {
    if (suggestions.status !== 'OK' || !suggestions.data.length) {
      if (e.key === 'Enter') {
        handleEnter(e);
      }
      return;
    }

    // Handle Navigation
    if (e.key === 'ArrowDown') {
      e.preventDefault(); // Prevents cursor from jumping to end of input
      setActiveIndex((prev) => (prev < suggestions.data.length - 1 ? prev + 1 : prev));
    } else if (e.key === 'ArrowUp') {
      e.preventDefault(); // Prevents cursor from jumping to start
      setActiveIndex((prev) => (prev > 0 ? prev - 1 : 0));
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (activeIndex >= 0 && activeIndex < suggestions.data.length) {
        handleSelect(suggestions.data[activeIndex]);
      }
    }
  };

  useEffect(() => {
    if (suggestions.status === 'OK') {
      setActiveIndex(0);
    }
  }, [suggestions.data, suggestions.status]);

  return (
    <>
      <Input
        type="text"
        style={isInterview ? { width: '400px' } : {}}
        value={value}
        autoFocus
        className="company-search data-hj-whitelist"
        placeholder={t('CompanyFind.nameoraddress')}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
      />
      {suggestions.status === 'OK' && !selectedValue && (
        <>
          {
            suggestions.data.map((prediction, index) => {
              const isActive = index === activeIndex;

              return (
                // eslint-disable-next-line max-len
                // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions,jsx-a11y/no-static-element-interactions
                <div
                  key={prediction.placeId}
                  onClick={() => handleSelect(prediction)}
                  className="custom-wrapper"
                  style={{
                    backgroundColor: isActive ? '#F5F5F5' : 'transparent',
                    cursor: 'pointer',
                  }}
                >
                  {prediction ? `${prediction.text.text}` : t('CompanyFind.noresults')}
                </div>
              );
            })
          }
        </>
      )}
      <div id="xaramida" />
    </>
  );
}

export default AutoComplete;
